import axios from 'axios';
import * as params from '../env';

// Define baseUrl API
const create = axios.create({
  baseURL: `${params.default.BASE_API}`,
});

create.interceptors.request.use(async (config) => {
  const token = localStorage.getItem('token');
  if (token) {
    /* eslint-disable no-param-reassign */
    config.headers.common.Authorization = `Bearer ${token}`;
  }

  return config;
}, error => error);

export default create;
